import { History } from 'history';
import { AppSetting } from 'dependencies/appsettings';
import { ApplicationState } from 'app/types-store';
import { globalVar } from 'app/infrastructure/universal/runtime';
import { debug, fatal } from 'app/infrastructure/log';
import { initialize, signin, processSigninResponse, processSignoutResponse } from './token-manager';
import { logoutRoute } from './constants';
import { ReceiveToken, ReceiveLogout, AuthenticationFailed } from 'app/shell/action-types';
import { hasToken } from 'app/infrastructure/auth/token-cache';
import { externalRedirect } from 'app/infrastructure/platform';

export async function processToken(store: Redux.Store<ApplicationState>, history: History) {

  initialize();

  const locationObj = globalVar('location');
  const searchParams = locationObj && new URLSearchParams(locationObj.search);

  const isHashAuthCallback = locationObj && locationObj.hash && locationObj.hash.includes('access_token');
  const isCodeAuthCallback = locationObj && searchParams.has('code') && searchParams.has('state');

  if (isHashAuthCallback || isCodeAuthCallback) {
    try {

      if(isHashAuthCallback) {
        debug('processToken', 'access_token found in url');
      } else if(isCodeAuthCallback) {
        debug('processToken', 'code found in url');
      }
      
      const signingResponse = await processSigninResponse(locationObj.href);

      store.dispatch(new ReceiveToken());

      if (signingResponse) {
        debug('processToken', 'redirecting after login', signingResponse);
        history.replace(signingResponse);
      }

    } catch (err) {
      fatal('Failed to process login response. Did you use HTTP instead of HTTPS..?', err);

      store.dispatch(new AuthenticationFailed());
    }

  } else if (locationObj && locationObj.pathname && locationObj.pathname.indexOf(logoutRoute) !== -1) {

    // processing logout response
    try {

      debug('processToken', 'logout path found in url');

      await processSignoutResponse();

      const logoutLandingPage = AppSetting.LogoutLandingPage;

      if (!!logoutLandingPage) {
        externalRedirect(logoutLandingPage);
      } else {
        store.dispatch(new ReceiveLogout());
        window?.sessionStorage?.clear();
        history.replace('/logout');
      }
    } catch (err) {
      fatal('unable to process signout response', err);

      store.dispatch(new AuthenticationFailed());
    }

  } else {

    // use cached token & abort
    if (hasToken()) {
      store.dispatch(new ReceiveToken());
      return;
    }

    // redirect for token
    try {

      debug('processToken', 'create redirect for token');
      await signin();

    } catch (err) {
      fatal('unable to redirect for token', err);

      store.dispatch(new AuthenticationFailed());
    }
  }
}
